<div class="loading-overlay" [ngClass]="{'active': isLoading}"></div>
<div class="loading-img" [ngClass]="{'active': isLoading}"></div>